import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import ErrorText from "./ErrorText";
import Header from "./Header";

const NotAllowedPage: FC = () => {
  const i18n = useI18n();

  return (
    <>
      <Header title={i18n.t.common.accessNotAllowed} />
      <ErrorText text={i18n.t.common.accessNotAllowedError} />
    </>
  );
};

export default NotAllowedPage;
